<!-- 首页-模块通用头部组件 -->
<template>
  <div class="theme-head">
    <div class="theme-box">
      <div class="theme-title-english">
        <span>{{apply.titleEnglish[0]}}</span>
        <span>{{apply.titleEnglish[1]}}</span>
      </div>
      <h4 class="theme-title">
        <span class="striping"><i class="line"></i><i class="dot"></i></span>
        <span class="apply-title">{{apply.title}}</span>
        <span class="striping"><i class="dot"></i><i class="line"></i></span>
      </h4>
      <!-- <div class="theme-intro" v-if="more === '进入应用'">
        {{ apply.intro }}
        <span class="theme-more theme-more-color" v-show="!isLink" @click="createPro"
          >{{ apply.more }}<i>&gt;</i></span
        >
        <span class="" @click="openNewWindow">
          <router-link v-show="isLink" class="theme-more theme-more-color" :to="apply.redirect"
            >{{ apply.more }}<i>&gt;</i></router-link
          >
        </span>
      </div> -->
      <div class="theme-intro" v-if="apply.title.indexOf('编辑器') !== -1">
        {{ apply.intro }}
        <el-dropdown class="theme-more" trigger="click" @command="handleCommand" placement="bottom" id="el-dropdown-editor">
          <span class="el-dropdown-link">
            {{ apply.more}}
            <i class="el-icon-arrow-right el-icon--right"></i>
          </span>
          <el-dropdown-menu class="editor-dropdown-menu" slot="dropdown">
            <el-dropdown-item
              v-for="item in editorTypes"
              :key="item.dictId"
              :command="item"
              >{{ item.dictTypeDesc }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="theme-intro" v-else>
        {{ apply.intro }}
        <span class="theme-more" v-show="!isLink" @click="createPro">
          {{ apply.more }}
          <!-- <i>&gt;</i> -->
          <i class="el-icon-arrow-right"></i>
        </span>
        <span class="" @click="openNewWindow">
          <router-link v-show="isLink" class="theme-more" :to="apply.redirect">
            {{ apply.more }}
            <!-- <i>&gt;</i> -->
            <i class="el-icon-arrow-right"></i>
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "HomeModuleHead",
  components: {},
  props: {
    isLink: {
      type: Boolean,
      default: true
    },
    apply: {
      type: Object,
      default: {}
    },
    // titleEnglish: String,
    // title: String,
    // intro: String,
    // more: String,
    // redirect: String,
    // titleBg: String,
    // openUrl: String
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'editorTypeArr',
      'editorTypeList',
    ]),
    editorTypes: {
      get(val) {
        let editorTypeList = [...this.editorTypeList]
        let editorTypeArr = this.editorTypeArr
        if (this.hasLogin) {
          let list = editorTypeList.filter((item) => {
            let hasAttr = false
            editorTypeArr.some((item2) => {
              if (new RegExp(item2.menuName).test(item.dictTypeDesc)) {
                hasAttr = true
                return
              }
            })
            return hasAttr
          })
          return list
        } else {
          return this.editorTypeList
        }
      },
      set(val) {},
    },
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions([]),
    createPro(evt) {
      this.$emit("myProject", evt);
    },
    openNewWindow() {
      if (this.apply.openUrl === "experinceAi") { 
         const { href } = this.$router.resolve({
            path: `/experian/index`,
          });
          window.open(href,"_blank")
        // window.open("../../../../modules/experianceAI/index.html");
      } else if (this.apply.openUrl === "application") {
        this.$router.push(this.apply.redirect);
        // this.$router.push({
        //   name: "application-index",
        //   query: {}
        // });
      } else if (this.apply.openUrl === "teaching") {
        this.$emit('toTeaching')
      }
    },
    // 选择编辑器
    handleCommand(val) {
      if (val) {
        let editorId = val.dictId,
          editorType

        this.editorTypes.forEach((item) => {
          if (item.dictId == editorId) {
            editorType = item.dictTypeDesc
          }
        })
        if (/(?=.*AI-T).*(?=.积木模式)/i.test(editorType)) {
          this.$router.push({
            name: 'ai-editor',
            query: {
              editorId: editorId,
              mode:'code',
            },
          })

        }else if (/AI-T/i.test(editorType)) {
          this.$router.push({
            name: 'ai-python-editor',
            query: {
              editorId: editorId,
            },
          })
        } else if (/(海龟|基础积木)/g.test(editorType)) {
          this.$router.push({
            name: 'baseBlock-editor',
            query: {
              editorId: editorId,
            },
          })
        } else if (/小智/g.test(editorType)) {
          this.$router.push({
            name: 'hardwareBlock-editor-B',
            query: {
              editorId: editorId,
            },
          })
        } else if (/小聪/g.test(editorType)) {
          this.$router.push({
            name: 'hardwareBlock-editor',
            query: {
              editorId: editorId,
            },
          })
        } else if (/python/g.test(editorType)) {
          this.$router.push({
            name: 'python-editor',
            query: {
              editorId: editorId,
            },
          })
        }
      }

    },
  }
};
</script>

<style lang="scss" scoped>
.theme-head {
  width: 100%;
  background-color: #fff;
}
.theme-box {
  width: 1200px;
  height: 250px;
  background-color: #fff;
  margin: 0 auto;
  overflow: hidden;
  .theme-title-english {
    margin-top: 66px;
    span {
      font-size: 52px;
      font-family: TsangerYunHei;
      font-weight: normal;
      line-height: 36px;
      &:first-child {
        color: #1CCCFF;
        margin-right: 20px;
      }
    }
  }

  .theme-title {
    height: 40px;
    color: #000001;
    font-size: 40px;
    line-height: 40px;
    font-weight: normal;
    margin: 16px 0 18px;
    display: flex;
    justify-content: center;
    .apply-title {
      margin: 0 18px;
    }
    .striping {
      width: 124px;
      display: flex;
      align-items: center;
      .line {
        flex: 1;
        height: 3px;
        background: #BEBEBE;
      }
      .dot {
        width: 7px;
        height: 7px;
        background: #BEBEBE;
        border-radius: 50%;
      }
    }
  }

  .theme-intro {
    color: #000000;
    height: 24px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    position: relative;
    .theme-more {
      font-size: 16px;
      color: #4279E8;
      position: absolute;
      right: 0;
      z-index: 2;
      cursor: pointer;
      // &:hover {
      //   color: #fff;
      // }
    }
  }
}

.el-dropdown-menu {
  background: linear-gradient(0deg, #B7CFEB 0%, #E7E7F3 56.00000000000001%);
  border-radius: 10px;
  ::v-deep.popper__arrow::after {
    border-bottom-color: #E8E8F3 !important;
  }
}
.el-dropdown-menu__item {
  color: #050505;
  &:hover {
    color: #fff !important;
    background: linear-gradient(90deg, #7F70FF, #3C7DFF);
  }
}
.el-icon--right {
  margin-left: 0;
}
</style>
